import { render, staticRenderFns } from "./DealForm.vue?vue&type=template&id=1c1c111d&scoped=true&"
import script from "./DealForm.vue?vue&type=script&lang=ts&"
export * from "./DealForm.vue?vue&type=script&lang=ts&"
import style0 from "./DealForm.vue?vue&type=style&index=0&id=1c1c111d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1c111d",
  null
  
)

export default component.exports